<template>
  <blue-panel>
    <template>
      <blue-panel-label-invoice :invoice="invoice" />
      <blue-panel-player-balance-label :balance="balance" />
      <blue-panel-player-insurance-label :insurance="insurance" />
      <blue-panel-player-description-label :description="description" />
    </template>
  </blue-panel>
</template>

<script>
  import BluePanelPlayerBalanceLabel from './PanelBlueLabelPlayerBalance';
  import BluePanelLabelInvoice from './PanelBlueLabelInvoice';
  import BluePanelPlayerDescriptionLabel from './PanelBlueLabelPlayerDescription';
  import BluePanelPlayerInsuranceLabel from './PanelBlueLabelPlayerInsurance';

  export default {
    name: "BluePanelPlayerInfo",
    props: ['invoice', 'balance', 'insurance', 'description'],
    components: {
      BluePanelPlayerBalanceLabel,
      BluePanelLabelInvoice,
      BluePanelPlayerDescriptionLabel,
      BluePanelPlayerInsuranceLabel,
    },
  }
</script>
